module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao1.png")
    }
  }), _vm._v(" 投资者如何找回密码？\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "reminder-text"
  }, [_vm._v("\n\t\t\t登录页面点击忘记密码\n\t\t")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-left": "5%"
    },
    attrs: {
      "src": require("../../common/images/findPwd.png"),
      "width": "90%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t自然人\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t填写注册手机号码，获取短信验证码，重新设置密码即可\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t机构\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t填写注册机构名称、注册手机号码、短信验证码，重新设置密码即可\n\t\t\t")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72e6002d"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Guide/findPwdGuide.vue
// module id = 1069
// module chunks = 1